import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component';
import {UmpireMatch} from '../umpire-match';
import {UmpireCompetition} from '../umpire-competition';
import {UmpireSeason} from '../umpire-season';
import {UmpireCompetitionSeason} from '../umpire-competition-season';
import {UmpireSquad} from '../umpire-squad';

export interface UmpireComponentMatch
  extends UmpireComponent<UmpireComponentTypeEnum.MATCH> {
  season: UmpireSeason | null;
  match: UmpireMatch | null;
  competition: UmpireCompetition;
  competition_season: UmpireCompetitionSeason | null;
  squad: UmpireSquad | null;
}
